import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserService } from 'app/users/shared/user.service';
import { HRMSService } from 'app/hrms/shared/hrms.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-offboard',
  templateUrl: './offboard.component.html',
  styleUrls: ['./offboard.component.scss']
})
export class OffboardComponent implements OnInit {
 employees:any;
 employeeOptions:any;
  myForm:FormGroup;
  employeeDetails:any;
  assets:any;
  documents:any;
  companyassets:any
  @Input("departments") departments;
  position:String = 'bottom-right';
  constructor(private userService:UserService, private hrmsService:HRMSService, private nf:NotificationToastService) { }

  ngOnInit() {
    this.initializeForm();
    this.getCompanyAssets();
    this.getAllEmployees();
    console.log("employees",this.employees, this.employeeOptions);
    this.assets = [];
    this.documents = [];
  }

  public initializeForm()
  {
    this.myForm = new FormGroup({
      employee: new FormControl('')
    });
  }
  public getAllEmployees()
  {
  var x = this.userService.getAllUser();
  x.snapshotChanges().subscribe(item=>{
    this.employees = [];
    this.employeeOptions = [];
    item.forEach(element =>{
      var y = element.payload.toJSON();
      if(!(element.payload.child("role").val() == "customer") && !(element.payload.child("boardingStatus").val() == 'offboard'))
      {
        y["key"] = element.key;
        this.employees.push(y);
        this.employeeOptions.push({label: String(element.payload.child("name").val()), value: element.payload.child("employeeId").val()});
      }
    });
  });
}
  onSubmit()
  {
    this.employees.forEach(e=>{
      if(e.employeeId == this.myForm.value.employee)
      {
        console.log("employees",e);
        this.employeeDetails = e;
        var assets =[];
        for(let asset in e.companyAssets)
        {
          assets.push(this.companyassets[e.companyAssets[asset]]);
        }
        this.employeeDetails.assets = assets;
        /* this.employeeDetails.documents = [ 
          {"doc" : e.photoUrl},
          {"doc" : e.drivingLicenceFront},
          {"doc" : e.drivingLicenceFront},
          {"doc" : e.passportFront},
          {"doc" : e.passportBack},
          {"doc" : e.visaCopy},
        ]; */
      }
    });
  }
  onClickAssetsList(event)
  {
    console.log("id",event.target.id);
    if(this.assets.includes(event.target.id))
    {
      console.log("includes",event.target.id);
      this.assets.splice(this.assets.indexOf(event.target.id), 1);
    }
    else{
      this.assets.push(event.target.id);
    }
    console.log("this.assets",this.assets,this.assets.length);
  }
  onClickDocumentsList(event)
  {
    console.log("id",event.target.id);
    if(this.documents.includes(event.target.id))
    {
      console.log("includes",event.target.id);
      this.documents.splice(this.documents.indexOf(event.target.id), 1);
    }
    else{
      this.documents.push(event.target.id);
    }
    console.log("this.assets",this.documents,this.documents.length);
  }
  offboard()
  {
   if(this.employeeDetails!=null)
   {
     if(this.assets.length == this.employeeDetails.assets.length && this.documents.length == 2)
     {
       console.log('offboard');
      this.hrmsService.offboard(this.employeeDetails.key).then(()=>{
        this.nf.addToast({title:'Offboard Success', msg:'Employee successfully offboarded', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        this.clear();
      });
     }
   } 
  }
  clear()
  {
    this.employeeDetails = null;
    this.myForm.reset();
  }
  getCompanyAssets()
{
  this.hrmsService.getAllAssets().snapshotChanges().subscribe((data)=>{
    this.companyassets = [];
    data.forEach(assest=>{
        this.companyassets[assest.key] = assest.payload.toJSON();
    });
  });
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/employee/offboard/offboard.component.ts